import React from 'react';
import CustomDropdown from '../shared/CustomDropdown';

/**
 * Service/Model Filter Component
 * Allows filtering by specific service or model variant
 */
const ServiceFilter = ({ value, onChange }) => {
  
  const handleFilterChange = (newValue) => {
    onChange(newValue);
  };

  // All available services/models in the monitor
  const serviceOptions = [
    { value: 'all', label: 'All Services' },
    { divider: true },
    { value: 'mini', label: 'ASI1 - Mini', icon: '🤖' },
    { value: 'extended', label: 'ASI1 - Extended', icon: '🤖' },
    { value: 'fast', label: 'ASI1 - Fast', icon: '⚡' },
    { value: 'graph', label: 'ASI1 - Graph', icon: '📊' },
    { divider: true },
    { value: 'imagex', label: 'Image Engine', icon: '🖼️' },
    { value: 'vision', label: 'Vision Engine', icon: '👁️' },
    { divider: true },
    { value: 'web', label: 'Web Search', icon: '🌐' },
    { value: 'structured', label: 'Structured Output', icon: '📋' },
    { value: 'tools', label: 'Tool Calling', icon: '🔧' },
    { value: 'streaming', label: 'Streaming', icon: '📡' }
  ];

  return (
    <div className="relative">
      <CustomDropdown
        label="Service"
        options={serviceOptions}
        value={value}
        onChange={handleFilterChange}
        placeholder="Select service"
      />
    </div>
  );
};

export default ServiceFilter;